<div class="main-content">
	<div class="container-fluid">
		<div class="row">
			<div class="col-md-12">
				<div class="card">
					<div class="card-header card-header-{{ color }}-1">
						<div class="ji-header">
							<h4 class="card-title mb-0 d-flex align-items-center">
								<button mat-icon-button type="button" class="ji-back-btn" (click)="back()" title="Back">
									<mat-icon>arrow_back</mat-icon>
								</button>
								<span>General Ledger Journal Inquiry</span>
							</h4>
							<div class="ji-header-actions">
								<button mat-raised-button
										color="warn"
										type="button"
										(click)="repostGl()"
										[disabled]="reposting"
										title="Repost General Ledger">
									<mat-icon *ngIf="!reposting">refresh</mat-icon>
									<svg *ngIf="reposting" class="spinner" width="18px" height="18px" viewBox="0 0 66 66" xmlns="http://www.w3.org/2000/svg">
										<circle class="path" fill="none" stroke-width="6" stroke-linecap="round" cx="33" cy="33" r="30"></circle>
									</svg>
									<span class="btn-label">{{ reposting ? 'Reposting...' : 'Repost GL' }}</span>
								</button>
							</div>
						</div>
					</div>
					<div class="card-body">

						<form [formGroup]="journalForm" (ngSubmit)="searchJournals()">
							<div class="row align-items-center g-2">
								<div class="col-md-2">
									<mat-form-field appearance="outline" class="w-100">
										<mat-label>Journal Number From</mat-label>
										<input matInput formControlName="numberFrom" type="number" />
									</mat-form-field>
								</div>
								<div class="col-md-2">
									<mat-form-field appearance="outline" class="w-100">
										<mat-label>Journal Number To</mat-label>
										<input matInput formControlName="numberTo" type="number" />
									</mat-form-field>
								</div>
								<div class="col-md-3">
									<mat-form-field appearance="outline" class="w-100">
										<mat-label>From Date</mat-label>
										<input matInput [matDatepicker]="fromDate" formControlName="fromDate" />
										<mat-datepicker-toggle matSuffix [for]="fromDate"></mat-datepicker-toggle>
										<mat-datepicker #fromDate></mat-datepicker>
									</mat-form-field>
								</div>
								<div class="col-md-3">
									<mat-form-field appearance="outline" class="w-100">
										<mat-label>To Date</mat-label>
										<input matInput [matDatepicker]="toDate" formControlName="toDate" />
										<mat-datepicker-toggle matSuffix [for]="toDate"></mat-datepicker-toggle>
										<mat-datepicker #toDate></mat-datepicker>
									</mat-form-field>
								</div>
								<div class="col-md-2">
									<mat-form-field appearance="outline" class="w-100">
										<mat-label>Posted</mat-label>
										<mat-select formControlName="posted">
											<mat-option *ngFor="let option of postedOptions" [value]="option.value">
												{{ option.label }}
											</mat-option>
										</mat-select>
									</mat-form-field>
								</div>
								<div class="col-md-2 text-end">
									<button mat-raised-button color="accent" type="submit" class="w-100">
										<mat-icon>search</mat-icon>
										<span class="btn-label">Search</span>
									</button>
								</div>
							</div>
						</form>

						<div class="col-md-12 text-center" *ngIf="isrunning">
							<svg class="spinner" width="65px" height="65px" viewBox="0 0 66 66" xmlns="http://www.w3.org/2000/svg">
								<circle class="path" fill="none" stroke-width="6" stroke-linecap="round" cx="33" cy="33" r="30"></circle>
							</svg>
						</div>

						<div *ngIf="journalData?.data?.length > 0">
							<div class="ji-search-bar mb-3">
								<mat-icon class="ji-search-icon">search</mat-icon>
								<input type="text"
									   class="form-control ji-search-input"
									   placeholder="Filter journals by account, description, tag, amount…"
									   [(ngModel)]="searchQuery"
									   (ngModelChange)="filterJournals()" />
							</div>

							<div *ngFor="let journal of filteredJournals" class="card ji-journal-card mb-3">
								<div class="ji-journal-header">
									<div class="ji-journal-meta">
										<span class="ji-journal-number">Journal #{{ journal.journalNumber }}</span>
										<span class="ji-journal-date">{{ journal.date | date:'mediumDate' }}</span>
										<span class="ji-journal-badge" *ngIf="isReversalEntry(journal)" title="This journal is a reversal of another journal">
											Reversal
										</span>
									</div>
									<div class="ji-journal-actions no-print">
										<button mat-stroked-button
												type="button"
												(click)="openEditJournalDescription(journal)"
												[disabled]="isReversalEntry(journal)"
												title="Edit description across all lines (and optionally the reversal)">
											<mat-icon>notes</mat-icon>
											<span class="btn-label">Edit Description</span>
										</button>
										<button mat-stroked-button
												color="primary"
												type="button"
												(click)="loadReversal(journal)"
												[disabled]="isReversalEntry(journal)"
												title="Load reversal into Journal Entry">
											<mat-icon>swap_horiz</mat-icon>
											<span class="btn-label">Reversal</span>
										</button>
										<button mat-stroked-button
												type="button"
												*ngIf="(journal.attachmentCount || 0) > 0"
												(click)="openAttachments(journal)"
												title="View attachments">
											<mat-icon>attach_file</mat-icon>
											<span class="btn-label">Attachments ({{ journal.attachmentCount }})</span>
										</button>
										<button mat-icon-button
												type="button"
												class="ji-export-btn ji-export-pdf"
												(click)="exportPdf(journal.journalNumber)"
												title="Export PDF">
											<mat-icon>picture_as_pdf</mat-icon>
										</button>
										<button mat-icon-button
												type="button"
												class="ji-export-btn ji-export-xls"
												(click)="exportXls(journal.journalNumber)"
												title="Export Excel">
											<mat-icon>grid_on</mat-icon>
										</button>
									</div>
								</div>
								<div class="card-body ji-journal-body">
									<div class="table-responsive" #journalTable [id]="'journalTable' + journal.journalNumber">
										<table class="table table-striped table-hover table-bordered ji-lines-table mb-0">
											<thead class="thead-dark">
												<tr>
													<th class="col-acct">Account</th>
													<th>Name</th>
													<th>Description</th>
													<th class="col-dept">Department</th>
													<th class="col-amount text-right">Amount</th>
													<th class="no-print text-center col-edit">Edit</th>
												</tr>
											</thead>
											<tbody>
												<tr *ngFor="let transaction of journal.transactions">
													<td class="col-acct">{{ transaction.accountCode }}</td>
													<td>{{ transaction.accountName }}</td>
													<td>{{ transaction.description }}</td>
													<td class="col-dept">{{ transaction.tagdescription || '—' }}</td>
													<td class="col-amount text-right"
														[class.text-danger]="transaction.amount < 0"
														[class.text-success]="transaction.amount >= 0">
														{{ transaction.amount | currency }}
													</td>
													<td class="no-print text-center col-edit">
														<button mat-icon-button
																color="primary"
																type="button"
																title="Edit this line's description / department"
																[disabled]="transaction.counterindex == null"
																(click)="openEditModal(transaction, journal)">
															<mat-icon>edit</mat-icon>
														</button>
													</td>
												</tr>
											</tbody>
										</table>
									</div>
								</div>
							</div>
						</div>
						<div *ngIf="journalData?.data?.length === 0">
							<h4 class="text-center text-muted"> No Results </h4>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</div>

<div class="attachments-modal-backdrop" *ngIf="attachmentsJournal" (click)="closeAttachments()"></div>
<div class="attachments-modal panel panel-default" *ngIf="attachmentsJournal">
	<div class="panel-heading d-flex align-items-center justify-content-between">
		<h5 class="mb-0">{{ selectedAttachment ? selectedAttachment.filename : 'Attachments — Journal #' + (attachmentsJournal?.journalNumber) }}</h5>
		<button mat-icon-button (click)="closeAttachments()"><mat-icon>close</mat-icon></button>
	</div>
	<div class="panel-body">
		<ng-container *ngIf="selectedAttachment">
			<button type="button" class="btn btn-sm btn-outline-secondary mb-2" (click)="clearAttachmentView()">
				<mat-icon class="align-middle" style="font-size: 18px; width: 18px; height: 18px;">arrow_back</mat-icon> Back to list
			</button>
			<div class="journal-attachment-viewer border rounded p-2 bg-light">
				<ng-container *ngIf="isPdf(selectedAttachment)">
					<iframe [src]="selectedAttachmentSafeUrl" class="journal-attachment-iframe" [attr.title]="selectedAttachment.filename"></iframe>
				</ng-container>
				<ng-container *ngIf="isImage(selectedAttachment)">
					<img [src]="getAttachmentViewUrl(selectedAttachment)" [alt]="selectedAttachment.filename" class="journal-attachment-img img-fluid" />
				</ng-container>
				<ng-container *ngIf="!isPdf(selectedAttachment) && !isImage(selectedAttachment)">
					<p class="text-muted mb-2">Preview not available for this file type.</p>
					<a [href]="getAttachmentDownloadUrl(selectedAttachment)" target="_blank" rel="noopener noreferrer" class="btn btn-primary" [attr.download]="selectedAttachment.filename">Download {{ selectedAttachment.filename }}</a>
				</ng-container>
			</div>
		</ng-container>
		<ng-container *ngIf="!selectedAttachment">
			<div *ngIf="attachmentsLoading" class="text-center p-3">Loading…</div>
			<div *ngIf="!attachmentsLoading && journalAttachmentsList.length === 0" class="text-muted p-3">No attachments.</div>
			<ul class="list-group list-group-flush" *ngIf="!attachmentsLoading && journalAttachmentsList.length">
				<li class="list-group-item d-flex justify-content-between align-items-center" *ngFor="let a of journalAttachmentsList">
					<span>{{ a.filename }}</span>
					<div class="d-flex align-items-center gap-2">
						<span class="small text-muted" *ngIf="a.created">{{ a.created }}</span>
						<button type="button" class="btn btn-sm btn-outline-primary me-1" *ngIf="isPdf(a) || isImage(a)" (click)="viewAttachment(a)">View</button>
						<a [href]="getAttachmentDownloadUrl(a)" target="_blank" rel="noopener noreferrer" class="btn btn-sm btn-outline-secondary" [attr.download]="a.filename">Download</a>
					</div>
				</li>
			</ul>
		</ng-container>
	</div>
</div>
